(function () {
    const STATUS_POPUP = "popup";
    const STATUS_STATIC = "static";
    const STATUS_DEFAULT = "default";
    const EVENT_NAME = "subscribe";

    document.addEventListener("spFormSubmitEvent", function (event) {
        const { detail: { formId } } = event;
        const currentStatus = determineStatus(formId);
        const dataLayerItem = {
            event: EVENT_NAME,
            type: currentStatus
        }

        dispatchAnalyticsEvent(dataLayerItem, EVENT_NAME);
    });

    function determineStatus(formId) {
        const formStatus = {
            "238198": STATUS_POPUP,
            "237941": STATUS_STATIC
        }

        return formStatus[formId] || STATUS_DEFAULT
    }

    function dispatchAnalyticsEvent(dataLayerItem, eventType) {
        const event = new CustomEvent('analytics-custom:subscribe', {
            bubbles: true,
            detail: { dataLayerItem, type: eventType }
        });
        document.dispatchEvent(event);
    }
}())
